// @flow
import type { CreditCardType, ACHMethod } from 'src/redux/reducers/payments'
// eslint-disable-next-line
export const getDefaultPaymentMethod = (methods: (?CreditCardType[] | ACHMethod[])) => methods?.find(item => item.default)
